import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Dashboard from '../Dashboard';
import Header from '../Header';
import ChangePassword from '../ChangePassword';
import ScriptsLoader from '../ScriptsLoader';
import GroupsManagerDashboard from '../GroupsManagerDashboard';
import NoticesLoader from '../NoticesLoader';
import SupportDashboard from '../SupportDashboard';
import Profile from '../Profile';
import Geofence from '../Geofence';
import GeofenceDetail from '../Geofence/GeofenceDetail';
import Trips from "../Trips/Trips";
import ConnectionRequestsDashboard from "../ConnectionRequestsDashboard";
import SubscriptionManagerDashboard from '../SubscriptionManagerDashboard';
import VehiclesManagerDashboard from '../VehiclesManagerDashboard';
import DriversManagerDashboard from '../DriversManagerDashboard';
import RouteTaskDashboard from "../RouteTaskDashboard";
import OrdersManagerDashboard from "../OrdersManagerDashboard";
import PaymentManagementDashboard from "../PaymentManagementDashboard";


@withRouter // I added @withRouter decorator because --> https://github.com/mobxjs/mobx-react/issues/210
@inject('noticesStore', 'authStore')
@observer
class Page extends Component {
  render() {
    return (
      <div style={{ minHeight: '100%', flex: 1 }}>
        <ScriptsLoader />
        <Header />
        <Switch>
          <Redirect from="/" exact to="/dashboard" />
          <Route path="/dashboard/:carId?" component={Dashboard} />
          <Route path="/change-password" component={ChangePassword} />
          <Route path="/groups-manager" component={GroupsManagerDashboard} />
          <Route path="/trips" component={Trips} />
          <Route path="/geofence-manager" component={Geofence} />
          <Route path="/geofence/:geofenceId?" component={GeofenceDetail} />
          <Route path="/subscription-manager" component={SubscriptionManagerDashboard} />
          <Route path="/support" component={SupportDashboard} />
          <Route path="/profile" component={Profile} />
          <Route path="/connection-requests" component={ConnectionRequestsDashboard} />
          <Route path="/payment-management" component={PaymentManagementDashboard} />
          <Route path="/vehicles-manager" component={VehiclesManagerDashboard} />
          <Route path="/drivers-manager" component={DriversManagerDashboard} />
          <Route path="/myfleet-planning" component={RouteTaskDashboard} />
          <Route path="/orders" component={OrdersManagerDashboard} />
        </Switch>
        <NoticesLoader notices={this.props.noticesStore.unreadFirstNotices} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/App/ContentRouter/ContentRouter.js